import React, {useMemo, useState } from "react"
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Box } from "@material-ui/core"
import { SimpleSelectOqt, TextOqt } from "../controls";
import { useFormik } from "formik";
import { WrapperComponent } from "../wrappers";
import { EditIcon, TimesIcon } from "./icons";
import * as immutable from 'object-path-immutable';
import { confirmDelete } from "../../../redux/utils";
import { useDrop } from "react-dnd";
import { ItemTypes } from "./DialogNode";
import { PaperComponent } from "..";
import { Editor } from "../controls/Editor";

var objectPath = require("object-path");



const constTiposTransformaciones = [
  {label: "Reemplazo", value: 'REEMPLAZO'},
  {label: "Mayúsculas", value: 'MAYUSCULAS'},
  {label: "Minúsculas", value: 'MINUSCULAS'},
  {label: "Mayúsculas minúsculas", value: 'MAYUSCULAS_MINUSCULAS'},
  {label: "Fórmula", value: 'FORMULA'},
  {label: "Valor", value: 'CONDICION_VALOR'},
];


export const Transformador = ({caption, tipoTransformacion = "FORMULA", valorOrigen, valorDestino, formula, onChange, name, formik, tiposTransformaciones = constTiposTransformaciones}) => {

  const [open, setOpen] = useState(false);



  const initialValue = () => {
    return formik ? (formik.values[name] ? formik.values[name] : { id: 0, ...(objectPath.get(formik.values, name) || {tipoTransformacion: "FORMULA"}) }) : {tipoTransformacion, valorOrigen, valorDestino, formula};
  }

  const fmk = useFormik({
    initialValues: initialValue(),
    onSubmit: values => {   
      setOpen(false);
      formik ? formik.setValues(immutable.set(formik.values, name, values)) : onChange(values);
    }
  })

  const [{ isOver }, drop] = useDrop(() => ({
    accept: ItemTypes.LIBRARY_ITEM,
    drop: (x, y) => {
      fmk.setFieldValue("formula", y.getItem().value);
      fmk.submitForm();
      //console.log({x, y, item: y.getItem()})
    },
    collect: monitor => ({
      isOver: !!monitor.isOver(),
    }),
  }), [])

  const handleClose = () => {
    setOpen(false);
  }

  const handleOpen = () => {
    setOpen(true);
  }

  const defaultObj = {tipoTransformacion: "FORMULA", formula: "..."};

  const label = useMemo(()=>{
    return (formik
      ? (formik.values[name] ? 
          (formik.values[name] || defaultObj) : 
          (objectPath.get(formik.values, name) || defaultObj))
      : {formula, tipoTransformacion} || defaultObj)
  }, [name, formula, formik]) 


  const handleRemove = () => {
    confirmDelete({
      html: `Está seguro de eliminar este transformador?<br/>${caption || "Edición de término"} ${(label.tipoTransformacion === "CONDICION_VALOR" ? "Condición" : label.formula)}`
    }).then(()=>{
      formik ? formik.setValues(immutable.set(formik.values, name, null)) : onChange(null);
      fmk.setValues(initialValue());
    })
  }


  return (
    <>
      <div 
        ref={drop}
        style={{
          width: "100%",
          height: "100%",
          minHeight: 40, 
          alignItems: "center", 
          display: "flex",
          border: "1px solid rgb(204, 204, 204)",
          padding:   "0px 4px",
        }}
      >
        <div style={{flex: 1, cursor: "pointer", lineBreak: "anywhere"}} onClick={handleOpen}>{label.tipoTransformacion === "CONDICION_VALOR" ? "Editar condición" : label.formula}</div> 
        <IconButton disabled={label === "..."} onClick={handleRemove} style={{padding: 8}}>
          <TimesIcon style={{width: 16, height: 16, fill: "hsl(0, 0%, 60%)"}}/>
        </IconButton>
        <IconButton onClick={handleOpen} style={{padding: 8}}>
          <EditIcon style={{width: 16, height: 16, fill: "hsl(0, 0%, 60%)"}}/>
        </IconButton>
      </div>
      <Dialog open={open}  aria-labelledby="form-dialog-title" onClose={handleClose} maxWidth="lg" fullWidth PaperComponent={PaperComponent}>
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          <Box display="flex" alignItems="center">
            <Box flexGrow={1} >{caption || "Edición de término"}</Box>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Grid container>
            <WrapperComponent caption="Tipo de transformación" Field={<SimpleSelectOqt name="tipoTransformacion" optionsList={tiposTransformaciones} formik={fmk} variant="standard" />}/>
            {fmk.values.tipoTransformacion !== "CONDICION_VALOR" && 
              /*<WrapperComponent caption="Fórmula" Field={<TextOqt autoFocus name="formula" formik={fmk} multiline={true}  variant="standard"/>}/>*/
              <WrapperComponent caption="Fórmula" inputContainerStyle={{flexDirection: "column", height: 350}} 
                Field={
                  <Editor 
                    autoFocus 
                    name="formula" 
                    value={fmk.values.formula} 
                    onValueChange={(code) => fmk.setFieldValue("formula", code)} 
                    mode="csharp"
                  />
                }
              />
            }
            {fmk.values.tipoTransformacion === "REEMPLAZO" && 
              <>
                <Grid item xs={6}>
                  <Grid container>
                    <WrapperComponent caption="Valor de origen" Field={<TextOqt name="valorOrigen" formik={fmk} multiline={true}  variant="standard"/>}/>
                  </Grid>
                </Grid>
                <Grid item xs={6}>
                  <Grid container>
                    <WrapperComponent caption="Valor de destino" Field={<TextOqt name="valorDestino" formik={fmk} multiline={true}  variant="standard"/>}/>
                  </Grid>
                </Grid>
              </>
            }
            {fmk.values.tipoTransformacion === "CONDICION_VALOR" && 
              <>
                <Grid item xs={6}>
                  <Grid container>
                    <WrapperComponent caption="Condición" Field={<TextOqt name="valorOrigen" formik={fmk} multiline={true}  variant="standard"/>}/>
                  </Grid>
                </Grid>
                <Grid item xs={6}>
                  <Grid container>
                    <WrapperComponent caption="Valor" Field={<TextOqt name="valorDestino" formik={fmk} multiline={true}  variant="standard"/>}/>
                  </Grid>
                </Grid>
              </>
            }
          </Grid>

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button onClick={fmk.submitForm}>Aceptar</Button>
        </DialogActions>
      </Dialog>


    </>

  )
}

